var _defs, _rect, _rect2, _g, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.32 79.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:3px;}.b,.c,.d,.e{stroke:#fff;stroke-miterlimit:10;}.b,.e{fill:none;}.c{stroke-width:3.53px;}.c,.d{fill:#669;}.d{stroke-width:3.53px;}.e{stroke-width:.89px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 25.21,
    y: -7.06,
    width: 28.9,
    height: 93.45,
    rx: 12.94,
    ry: 12.94,
    transform: "translate(-16.43 39.66) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 25.21,
    y: -7.06,
    width: 28.9,
    height: 93.43,
    rx: 12.94,
    ry: 12.94,
    transform: "translate(39.66 -16.43) rotate(45)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 23.52,
    cy: 44.7,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 30.48,
    cy: 37.74,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 32.11,
    cy: 46.78,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 34.19,
    cy: 55.37,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 41.15,
    cy: 48.41,
    r: 1.89
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 37.38,
    cy: 30.84,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 44.35,
    cy: 23.87,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 45.98,
    cy: 32.91,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 39.27,
    cy: 39.62,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 48.05,
    cy: 41.51,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 55.02,
    cy: 34.54,
    r: 1.89
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 13.2,
    y1: 45.23,
    x2: 34.67,
    y2: 65.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 44.5,
    y1: 13.93,
    x2: 65.97,
    y2: 34.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9528ec2ac9abb976aa99c0b6fa601cae.svg";
export { ForwardRef as ReactComponent };